import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Sparkles, Droplet, CheckCircle } from 'lucide-react';
const services = [{
  icon: Scissors,
  name: 'Corte Clásico',
  desc: 'Corte tradicional a tijera o máquina con terminaciones perfectas.'
}, {
  icon: Sparkles,
  name: 'Fade / Degradé',
  desc: 'Degradado profesional con navaja, adaptado a tu estilo.'
}, {
  icon: Droplet,
  name: 'Arreglo de Barba',
  desc: 'Perfilado, recorte y ritual de toalla caliente para tu barba.'
}, {
  icon: CheckCircle,
  name: 'Diseño de Cejas',
  desc: 'Limpieza y perfilado de cejas para enmarcar tu mirada.'
}, {
  icon: Sparkles,
  name: 'Tratamiento Capilar',
  desc: 'Lavado premium y aplicación de productos para el cuidado capilar.'
}, {
  icon: Scissors,
  name: 'Corte + Barba',
  desc: 'El combo completo. La experiencia Prince definitiva.'
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-dark" data-id="element-129">
      <div className="container mx-auto px-6" data-id="element-130">
        <div className="text-center mb-16" data-id="element-131">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-132">
            Nuestros <span className="text-gold" data-id="element-133">Servicios</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-134">
            Atención al detalle y técnicas de vanguardia para un resultado
            impecable.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-135">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card p-8 rounded-sm border border-white/5 hover:border-gold/30 transition-colors group" data-id="element-136">
              <service.icon className="text-gold w-10 h-10 mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-137" />
              <h3 className="text-xl font-bold mb-3" data-id="element-138">{service.name}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-139">
                {service.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}